import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CartService } from '../services/cart.service';
import { CartItem } from '../models/cart.models';
import { FormsModule } from '@angular/forms';
import { Product } from '../models/admin.models';

import { NavbarComponent } from '../shared/navbar/navbar.component';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, NavbarComponent, CurrencyPipe],
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  private cartService = inject(CartService);
  
  cartItems: CartItem[] = [];
  subtotal = 0;
  shippingTotal = 0;
  grandTotal = 0;
  totalItems = 0;
  
  // For quantity dropdown options
  quantityOptions = Array.from({ length: 10 }, (_, i) => i + 1);

  ngOnInit() {
    this.cartService.refreshCart();
    this.cartService.getCartState().subscribe(state => {
      this.cartItems = [...state.items]; // Create a new array reference
      // Recalculate subtotal based on discounted prices to ensure it matches UI
      this.subtotal = this.cartItems.reduce((total, item) => {
        return total + (this.getDiscountedPrice(item.product) * item.quantity);
      }, 0);
      
      this.shippingTotal = (this.subtotal > 0 && this.subtotal < 499) ? 49 : 0;
      this.grandTotal = this.subtotal + this.shippingTotal;
      
      this.totalItems = state.totalItems;
    });
  }

  updateQuantity(productId: string, quantity: number) {
    const newQuantity = Number(quantity);
    this.cartService.updateQuantity(productId, newQuantity);
  }

  removeItem(productId: string) {
    if (confirm('Are you sure you want to remove this item from your cart?')) {
      this.cartService.removeFromCart(productId);
    }
  }

  getDiscountedPrice(product: Product): number {
    if (!product.discount) return product.price;
    return product.price * (1 - product.discount / 100);
  }

  getImageUrl(image: string): string {
    if (!image) return '/assets/placeholder-botanical.jpg';
    return image.startsWith('http') ? image : '/' + image;
  }

  getTotalSavings(): number {
    return this.cartItems.reduce((total, item) => {
      if (item.product.discount) {
        const originalPrice = item.product.price * item.quantity;
        const discountedPrice = this.getDiscountedPrice(item.product) * item.quantity;
        return total + (originalPrice - discountedPrice);
      }
      return total;
    }, 0);
  }
}
